import React from "react"
import { Link } from "gatsby"
import styled from 'styled-components'
import NavStyles from "../styles/nav-styles"

class Nav extends React.Component { 
    render() {
        return (
            <NavStyles data-test="nav">   
                <li> 
                    <StyledLink to="/">
                        Moscow
                    </StyledLink>
                </li>
                <li> 
                    <StyledLink to="/attractions/">
                        Attractions
                    </StyledLink>
                </li>
                <li> 
                    <StyledLink to="/hotels/">
                        Hotels
                    </StyledLink>
                </li>
                <li> 
                    <StyledLink to="/moscow-strip-clubs/">
                        Strip Clubs
                    </StyledLink>
                </li>
                <li> 
                    <StyledLink to="/moscow-erotic-massage/">
                        Erotic Massage
                    </StyledLink>
                </li>
                <li> 
                    <StyledLink to="/moscow-nightclubs/">
                        Nightlife
                    </StyledLink>
                </li>
                <li> 
                    <StyledLink to="/best-restaurants-moscow/">
                        Restaurants
                    </StyledLink>
                </li>
            </NavStyles>              
        ) 
    }

}

const StyledLink = styled(Link)`
    padding: 1rem 2rem;
    display: flex;
    align-items: center;
    position: relative;
    text-transform: uppercase;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    background: none;
    border: 0;
    cursor: pointer;
    color: ${props => props.theme.black};
    @media (max-width: 700px) {
      font-size: 1.4rem;
      padding: 0 10px;
    }
    &:before {
      content: '';
      width: 2px;
      background: ${props => props.theme.lightgrey};
      height: 100%;
      left: 0;
      position: absolute;
      transform: skew(-20deg);
      top: 0;
      bottom: 0;
    }
    &:after {
      height: 2px;
      background: red;
      content: '';
      width: 0;
      position: absolute;
      transform: translateX(-50%);
      transition: width 0.4s;
      transition-timing-function: cubic-bezier(1, -0.65, 0, 2.31);
      left: 50%;
      margin-top: 2rem;
    }
    &:hover,
    &:focus {
      outline: none;
      &:after {
        width: calc(100% - 60px);
      } 
    } 
`;


export default Nav;